import React from "react";
import { HeaderStyled } from "./style";
import config from "../../config/enviroment";
var Header = function () {
    return React.createElement(HeaderStyled, null,
        React.createElement("img", { src: config.urlS3 + "/wom/logo.png", alt: "logo wom" }));
};
export default Header;
